import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 42.52 42.52"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m23.44 30.04.06.07c-5.16-2.79-8.41-6.75-10.46-10.55l5.58-4.7-2.04-7.96H7.54l.05 1.04c.01.25 1.42 24.85 27.62 27.68l1.11.12v-8.02l-7.2-1.99-5.67 4.3ZM9.68 8.9h5.35l1.34 5.24-4.24 3.57c-1.69-3.76-2.26-7.15-2.45-8.81Zm24.63 20.34v4.25c-3.42-.46-6.36-1.32-8.9-2.45l4.12-3.13 4.78 1.32Z" }, null, -1)
  ])))
}
export default { render: render }